/**
 * Vue 组件异常采集
 */
import type { App, ComponentPublicInstance } from 'vue';
import { MONITOR_CONFIG } from '@/monitor/config';
import { isRequestTimeout, readApiContext } from '@/monitor/collectors/apiError';
import { track } from '@/monitor/core/aggregator';

/** 从组件实例上取组件名，用于定位是哪个组件炸的 */
const componentName = (instance: ComponentPublicInstance | null): string => {
  const type = instance?.$?.type as { name?: string; __name?: string } | undefined;
  return type?.name ?? type?.__name ?? '未知组件';
};

export const setupVueErrorCollector = (app: App): void => {
  app.config.errorHandler = (
    err: unknown,
    instance: ComponentPublicInstance | null,
    info: string,
  ) => {
    const error = err instanceof Error ? err : new Error(String(err));
    if (isRequestTimeout(err)) {
      console.error(err);
      return;
    }
    /** 接口错误由请求层统一处理，冒泡到组件层时不再重复上报。 */
    const apiContext = readApiContext(err);
    if (apiContext) {
      console.error(err);
      return;
    }
    track({
      type: 'vue_error',
      level: 'error',
      title: 'Vue 组件异常',
      message: error.message,
      stack: error.stack?.split('\n').slice(0, MONITOR_CONFIG.STACK_LINES).join('\n'),
      extra: { 组件: componentName(instance), 钩子: info },
      timestamp: Date.now(),
    });
    /** 接了监控不代表控制台就不用报错，开发时仍要能直接看到原始错误 */
    console.error(err);
  };
};
